import type { ApiDeviceBranding } from "../_types/device-brandings.types";

/** Sample asset ids used only inside the Branding prototype UI (not real asset rows). */
export const BRANDING_PROTOTYPE_ASSET_OPTIONS = [
  { id: "22222222-2222-4222-8222-222222222201", label: "Wallpaper — clinic lobby", kind: "image" as const },
  { id: "22222222-2222-4222-8222-222222222202", label: "Wallpaper — exam room", kind: "image" as const },
  { id: "22222222-2222-4222-8222-222222222203", label: "Logo — Vetty mark", kind: "image" as const },
  { id: "22222222-2222-4222-8222-222222222204", label: "Logo — partner clinic", kind: "image" as const },
  { id: "22222222-2222-4222-8222-222222222205", label: "Alert — soft chime", kind: "audio" as const },
  { id: "22222222-2222-4222-8222-222222222206", label: "Alert — urgent ping", kind: "audio" as const },
];

export const DEVICE_BRANDING_PROTOTYPE_SAMPLES: ApiDeviceBranding[] = [
  {
    id: "33333333-3333-4333-8333-333333333301",
    name: "Vetty Kiosk — default",
    description: "Default orange accent with lobby wallpaper.",
    wallpaperAssetId: "22222222-2222-4222-8222-222222222201",
    logoAssetId: "22222222-2222-4222-8222-222222222203",
    alertSoundAssetId: "22222222-2222-4222-8222-222222222205",
    displayName: "Vetty",
    accentColor: "#ff541f",
    extra: { prototype: true },
    configVersion: 2,
    createdAt: Date.UTC(2026, 2, 9, 12, 0, 0),
    updatedAt: Date.UTC(2026, 2, 17, 12, 0, 0),
  },
  {
    id: "33333333-3333-4333-8333-333333333302",
    name: "Northwind Clinics",
    description: "Partner clinic preview theme.",
    wallpaperAssetId: "22222222-2222-4222-8222-222222222202",
    logoAssetId: "22222222-2222-4222-8222-222222222204",
    alertSoundAssetId: "22222222-2222-4222-8222-222222222206",
    displayName: "Northwind",
    accentColor: "#8c2d0f",
    extra: { prototype: true },
    configVersion: 1,
    createdAt: Date.UTC(2026, 2, 7, 12, 0, 0),
    updatedAt: Date.UTC(2026, 2, 14, 12, 0, 0),
  },
  {
    id: "33333333-3333-4333-8333-333333333303",
    name: "Draft — lakeside",
    description: "Unpublished draft accent exploration.",
    wallpaperAssetId: null,
    logoAssetId: "22222222-2222-4222-8222-222222222203",
    alertSoundAssetId: null,
    displayName: "Lakeside",
    accentColor: "#b53a12",
    extra: { prototype: true, publishStatus: "draft" },
    configVersion: 1,
    createdAt: Date.UTC(2026, 2, 4, 12, 0, 0),
    updatedAt: Date.UTC(2026, 2, 11, 12, 0, 0),
  },
];

export function createPrototypeBrandingId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `00000000-0000-4000-8000-${String(Date.now()).padStart(12, "0").slice(-12)}`;
}

export function prototypeAssetLabel(assetId: string | null | undefined): string {
  if (!assetId) return "—";
  return BRANDING_PROTOTYPE_ASSET_OPTIONS.find((a) => a.id === assetId)?.label ?? assetId;
}
